import { call, put } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import ApiBalanceSheet from '../../Api/ApiBalanceSheet';
import ToastMsg from '../../Components/ToastMsg';
import { creators as BalanceSheetActions } from '../../Reducers/Reporting/BalanceSheet';

export function* getBalanceSheetQuerys({ payload }) {
  try {
    const response = yield call(ApiBalanceSheet.getQuerys, payload.dimdate);
    if (response.status === 200) {
      yield put(BalanceSheetActions.glbsSuccess({ queryResult: response.data }));
    } else {
      if (response.status !== 401) toast.error(ToastMsg,
        {
          data : {
            title: "BalanceSheet",
            text: response.message,
          },
        },
      );
      yield put(BalanceSheetActions.glbsFailure(response.message));
    }
  } catch (e) {
    yield put(BalanceSheetActions.glbsFailure(e));
  }
}
